type NotchedBackgroundProps = {
  width?: string;
  height?: string;
  tagLeft?: string;
  children?: React.ReactNode;
};

export const NotchedBackground = ({ width = '100%', height = '100%', tagLeft = '34px', children }: NotchedBackgroundProps) => {
  return (
    <div
      style={{
        width,
        height,
        padding: 0,
        background:
          'linear-gradient(137.71deg, #2B2D2F 4.64%, #2B2D2F 95.71%) padding-box, linear-gradient(to bottom right, #2B2D2F 60%, #1F2022 90%) border-box',
        // boxShadow:
        //   '176px 223px 80px rgba(0, 0, 0, 0.01), 113px 143px 73px rgba(0, 0, 0, 0.04), 63px 80px 61px rgba(0, 0, 0, 0.15), 28px 36px 45px rgba(0, 0, 0, 0.26), 7px 9px 25px rgba(0, 0, 0, 0.29)',
        border: '1px solid transparent',
        borderRadius: '18px',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: tagLeft,
        }}
      >
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            style={{
              float: 'left',
              width: '3px',
              height: '13px',
              marginLeft: '2px',
              background: 'linear-gradient(0deg, #191A1B 0%, #1E2021 100%)',
              boxShadow:
                'inset 9px 35px 14px rgba(0, 0, 0, 0.03), inset 5px 20px 12px rgba(0, 0, 0, 0.1), inset 2px 9px 9px rgba(0, 0, 0, 0.17), inset 1px 2px 5px rgba(0, 0, 0, 0.2)',
            }}
          />
        ))}
      </div>
      {children}
    </div>
  );
};
